import { observer } from 'mobx-react-lite';

import usePresenter from './presenter';

const ForceUpdateHandler = () => {
  usePresenter();

  return null;
};

export default observer(ForceUpdateHandler);
